<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="success"
          light
          max-width="100%"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Sign up / Login
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <amplify-authenticator username-alias="email">
              <amplify-sign-in
                slot="sign-in"
                username-alias="email"
              />
              <amplify-sign-up
                slot="sign-up"
                username-alias="email"
                :form-fields.prop="formFields"
              />
            </amplify-authenticator>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  // import { AuthFormField, I18n, Translations } from 'aws-amplify'

  export default {
    name: 'PublicAuth',

    data: () => ({
      formFields: [
        {
          type: 'email',
          required: true,
        },
        {
          type: 'password',
          required: true,
        },
      ],
    }),
  }
</script>
